<template>
  <FormCreate
    :errors="errors"
    :fields="fields"
    model="origin"
    @submitted="create"
  >
    <div class="elr-row">
      <div class="elr-col-full">
        <InputText
          label="Origin Name"
          v-model="formData.name"
          fieldName="name"
          :errors="errors"
          errorMessage="Please add origin name"
          :required=true
        />
      </div>
      <div class="elr-col-full">
        <InputText
          label="Origin Demonym"
          v-model="formData.demonym"
          fieldName="demonym"
          :errors="errors"
          errorMessage="Please add origin demonym"
          :required=true
        />
      </div>
    </div>
    <div class="elr-row">
      <div class="elr-col-full">
        <InputTextArea
          label="Description"
          v-model="formData.description"
          fieldName="description"
        />
      </div>
    </div>
  </FormCreate>
</template>

<script>
import FormCreate from '../FormCreate/FormCreate';
import InputText from '../InputText/InputText';
import InputTextArea from '../InputTextArea/InputTextArea';

export default {
  name: 'FormOriginCreate',
  data() {
    return {
      formData: {
        name: null,
        demonym: null,
        description: null
      },
      fields: [
        'name',
        'demonym',
        'description'
      ]
    };
  },
  components: {
    FormCreate,
    InputText,
    InputTextArea
  },
  computed: {
    errors() {
      return this.$store.state.origin.errors ? this.$store.state.origin.errors[0] : {};
    }
  },
  methods: {
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    },
    resetForm() {
      this.formData = {
        name: null,
        demonym: null,
        description: null
      };
    },
    create() {
      this.$store.dispatch('origin/ADD', this.formData);
    }
  }
};
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

.error-message {
  color: $red;
}
</style>

